import { initClient } from "rwsdk/client";
import "./app/styles/tailwind.css"

initClient();
